import { useThree } from '@react-three/fiber';
import { DoubleSide, Vector3, Quaternion } from 'three';

const up = new Vector3(0,0,1);
const quat = new Quaternion();

export default function Probe(props) {
  const { scene } = useThree();

  const {
    show,
    position,
    normal,
    highlighted
  } = props;

  const length = 1;
  const diameter = 1.5/25.4;
  const probeDiameter = 4./25.4;

  quat.setFromUnitVectors(up, normal || up);

  const setLayer = (obj) => {
    if(obj) {
      obj.traverse((o) => {
        o.layers.mask = 1 << 0;
      });
    }
  };

  return <group visible={show} position={position} quaternion={[ quat.x, quat.y, quat.z, quat.w ]} ref={setLayer} {...props}>
    <mesh rotation-x={Math.PI/2} position-z={length*.5}>
      <cylinderGeometry args={[ diameter*.5, diameter*.5, length, 20, 1, false, 0, 2*Math.PI ]}/>
      <meshStandardMaterial metalness={.9} roughness={.232} color={0xbbbbbb} envMap={scene.envMap} envMapIntensity={2} side={DoubleSide} emissive={highlighted ? [ .2, .2, 0 ] : [0,0,0]}/>
    </mesh> 
    <mesh>
      <sphereGeometry args={[ probeDiameter*.5, 40, 20 ]}/>
      <meshPhysicalMaterial clearcoat={1} sheen={1} metalness={0} roughness={.1} color={0x882863} envMap={scene.envMap} envMapIntensity={1.5} emissive={highlighted ? [ .2, .2, 0 ] : [0,0,0]}/>
    </mesh>
  </group>;
}
